import { lazy } from "react";
import type { IntakeConversationProps } from "./IntakeConversation";
const IntakeConversation = lazy(() => import("./IntakeConversation").then(module => ({ default: module.IntakeConversation })));
import { setStudioView } from "../workspace/studio-views";

export function mountIntakeConversation(
  slot: HTMLElement,
  props: IntakeConversationProps,
) {
  setStudioView("intake-conversation", "guided-intake", <IntakeConversation {...props} />);
}
